export default __webpack_public_path__ + "726c5ae39aa09c534c4a9b9c9327a2e3.png";